import { ComponentRef, Injectable } from '@angular/core';
import {
  DialogCloseResult,
  DialogRef,
  DialogResult,
  DialogService,
} from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { AssignActionItemDialogComponent } from '../components/assign-action-item-dialog/assign-action-item-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class AssignActionItemsDialogService {
  constructor(private dialogService: DialogService) {}
  public open(): {
    result$: Observable<DialogCloseResult | DialogResult>;
    instance: AssignActionItemDialogComponent;
  } {
    const dialog: DialogRef = this.dialogService.open({
      content: AssignActionItemDialogComponent,
      minHeight: '300px',
      width: '900px',
      maxWidth: '1900px',
      cssClass: 'send-action-item-dialog',
    });
    const content: ComponentRef<AssignActionItemDialogComponent> =
      dialog.content as ComponentRef<AssignActionItemDialogComponent>;
    const instance: AssignActionItemDialogComponent = content.instance;
    return {
      result$: dialog.result as Observable<DialogCloseResult | DialogResult>,
      instance,
    };
  }
}
